import React, { useState } from 'react';
import { getAllAlmaXSubmissions } from '../../../services/apiService';
import Rating from '@material-ui/lab/Rating';

import moment from 'moment';

import { ExpandLess, ExpandMore } from '@material-ui/icons';
import RenderProfilePic from '../../../extras/RenderProfilePic';

import {
  Modal,
  Radio,
  List,
  // ListSubheader,
  ListItem,
  ListItemText,
  Collapse,
} from '@material-ui/core';

const timeFormat = 'DD MMM YYYY hh:mm:ss a';

const urlStringLength = 25;

export default function ViewFeedbackModal({
  displayText,
  goalType,
  assignmentId,
  userId,
  assignmentImgUrl,
  assignmentName,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [collapseArray, setCollapseArray] = useState([]);
  const [submissionsObj, setSubmissionsObj] = useState({});
  const [loading, setLoading] = useState(false);

  const [ratingKeyNameMap, setRatingKeyNameMap] = useState({});

  const handleClick = (index) => {
    const tempArr = collapseArray.slice();
    tempArr[index] = !collapseArray[index];
    setCollapseArray(tempArr);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleTextClick = async () => {
    setOpenModal(true);

    setLoading(true);
    try {
      const response = await getAllAlmaXSubmissions(
        goalType,
        assignmentId,
        userId
      );
      setSubmissionsObj(response);

      const tempCollapseArray = [];
      for (let i = 0; i < response?.submissions?.length; i++) {
        if (i === response?.submissions?.length - 1)
          tempCollapseArray.push(true);
        else tempCollapseArray.push(false);
      }

      mapRatingKeyToName(response.assignment?.attributes?.rubrics);
      setCollapseArray(tempCollapseArray);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setSubmissionsObj({});
      setLoading(false);
    }
  };

  const mapRatingKeyToName = (rubricsDefinitionArray) => {
    if (!rubricsDefinitionArray) return;
    const tempObj = {};
    for (let i = 0; i < rubricsDefinitionArray.length; i++) {
      tempObj[rubricsDefinitionArray[i].rubricKey] =
        rubricsDefinitionArray[i].rubricName;
    }

    setRatingKeyNameMap(tempObj);
  };

  return (
    <div>
      <div
        className='flex items-center h-full text-blue-600 cursor-pointer'
        onClick={handleTextClick}
      >
        {displayText || 'View Feedback'}
      </div>

      <Modal
        open={openModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        className=''
      >
        <div
          style={{ maxHeight: '80vh' }}
          className='relative overflow-y-auto top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'
        >
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={handleClose}
          >
            X
          </div>
          <h3 className='font-medium'>
            <div className='flex items-center mb-2'>
              {assignmentImgUrl ? (
                <img src={assignmentImgUrl} className='w-8 h-8 rounded-full' />
              ) : (
                <RenderProfilePic name={assignmentName} thumbnail='' size='2' />
              )}

              <div className='flex-auto'>
                <h3 className='font-bold'>{assignmentName}</h3>
              </div>
            </div>
          </h3>

          <hr className='mt-2 mb-4' />
          {loading ? (
            <div className='flex justify-center'>Loading...</div>
          ) : (
            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
            >
              {submissionsObj?.submissions?.map((submissionItem, index) => {
                return (
                  <div key={index}>
                    <ListItem
                      onClick={() => {
                        handleClick(index);
                      }}
                      className='rounded my-3'
                      style={{ background: '#8491A0' }}
                    >
                      <ListItemText
                        className='text-white'
                        primary={`Attempt ${submissionItem.attemptNumber}`}
                      />
                      {collapseArray[index] ? (
                        <ExpandLess className='text-white' />
                      ) : (
                        <ExpandMore className='text-white' />
                      )}
                    </ListItem>
                    <Collapse
                      in={collapseArray[index]}
                      timeout='auto'
                      unmountOnExit
                    >
                      <div className='p-3'>
                        <div className='flex-auto mb-3'>
                          <div className='mr-2  flex  gap-3'>
                            <div className='flex-auto'>
                              <div className='flex'>
                                <h3 className='font-bold '>Code link:</h3>
                                <a
                                  href={
                                    submissionItem?.submittedSolution?.codeLink
                                  }
                                  target='_blank'
                                  rel='noreferrer'
                                  className='flex items-center gap-2 ml-2 font-bold text-blue-600'
                                >
                                  {submissionItem?.submittedSolution?.codeLink
                                    ?.length > urlStringLength
                                    ? submissionItem?.submittedSolution?.codeLink?.slice(
                                        0,
                                        urlStringLength
                                      ) + '...'
                                    : submissionItem?.submittedSolution
                                        ?.codeLink}
                                </a>
                              </div>
                              <h3 className='font-bold'>
                                Score: {submissionItem?.credits}
                              </h3>
                            </div>
                            <div>
                              <div className='text-gray-500 text-sm grow-0'>
                                Submitted on{' '}
                                {moment(submissionItem?.submittedAt).format(
                                  timeFormat
                                )}
                              </div>
                              {submissionItem?.evaluatedAt && (
                                <div className='text-gray-500 text-sm grow-0'>
                                  Evaluated on{' '}
                                  {moment(submissionItem?.evaluatedAt).format(
                                    timeFormat
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <hr className='mb-4' />
                        <div className='font-bold'>Ratings & Feedback</div>

                        {submissionItem?.coachFeedback?.ratings &&
                          Object.keys(
                            submissionItem?.coachFeedback?.ratings
                          ).map((rubricKey, index) => (
                            <div className='flex mb-2' key={index}>
                              <div className='w-64 text-gray-400 text-sm'>
                                {ratingKeyNameMap[rubricKey]}
                              </div>

                              <Rating
                                max={10}
                                name={ratingKeyNameMap[rubricKey]}
                                value={
                                  submissionItem?.coachFeedback?.ratings[
                                    rubricKey
                                  ]
                                }
                                disabled={true}
                              />
                            </div>
                          ))}

                        <hr className='mt-4 mb-4' />

                        <div className='text-gray-400 text-sm'>Plaigarism</div>
                        <div className='flex items-center -mb-2 -ml-2'>
                          <Radio
                            color='primary'
                            name='plaigarism'
                            value='self_written'
                            checked={
                              submissionItem?.coachFeedback
                                ?.plagiarisedSolution === false
                            }
                            disabled={true}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            Self-written submission
                          </span>
                        </div>
                        <div className='flex items-center -mb-2 -ml-2'>
                          <Radio
                            color='primary'
                            name='plaigarism'
                            value='plagiarised'
                            checked={
                              submissionItem?.coachFeedback?.plagiarisedSolution
                            }
                            disabled={true}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            Plagiarised submission
                          </span>
                        </div>

                        <div className='text-sm text-gray-400 mt-4'>
                          Feedback
                        </div>
                        <textarea
                          disabled={true}
                          rows='4'
                          className='w-full border border-gray-300 focus:outline-none focus:border-blue-c1 focus:ring-1 focus:ring-blue-c1 rounded-lg p-2'
                          value={submissionItem?.coachFeedback?.feedback}
                        />
                      </div>
                    </Collapse>
                  </div>
                );
              })}
            </List>
          )}
        </div>
      </Modal>
    </div>
  );
}
